@if (isLoading()) { <div class="mat-spinner"><mat-spinner></mat-spinner></div> }
@else {
    <mat-sidenav-container class="nav-container">
        <!--#region Navigation menu -->
         @if (
            isLoggedIn()
            && !onChangePasswordScreen
        ) { 
            
            <mat-sidenav
                #sidenav
                [mode]="
                    navService.isNavFixed() 
                    && !navService.isMobile() ? 'side' : 'over'
                " 
                [opened]="navService.isNavOpen()" 
                (openedChange)="navService.toggleNavOpen($event)"
                (mouseleave)="navService.toggleNavOpen(navService.isNavFixed())" 
                class="no-print"	
            >
                <pcg-mat-side-nav
                    [user]="user"
                    id="sidenav"
				    class="no-print"
                ></pcg-mat-side-nav>
            </mat-sidenav>
        }
        <!--#endregion-->

        <!-- Rest of the site -->
        <mat-sidenav-content [ngClass]="{'darker': navService.isNavOpen() }">
            <!--#region Nav drawer -->
            @if (
                !navService.isMobile()
                && !navService.isNavFixed()
                && isLoggedIn()
                && !onChangePasswordScreen
            ) {
                <nav class="nav-drawer no-print">
                    <div class="nav-drawer-image">
                        <button 
                            class="d-flex align-items-center justify-content-center mt-2 fixed-toggle-btn"
                            (click)="navService.toggleNavFixed(true)" 
                        >
                            <fa-icon 
                                [icon]="faArrowRight" 
                                class="fa-lg"
                            ></fa-icon>
                        </button>
                    </div>

                    <a 
                        class="drawer-icon"
                        (click)="navService.homeButtonClick()"
                    >
                        <fa-icon
                            class="drawer-icon pointer"
                            [icon]="faHouse"
                            [class.active-drawer-item]="navService.selectedMainNav() === 'Home'"
                        ></fa-icon>
                    </a>

                    @for (nav of navService.navRoutes(); track nav;) {
                        @if (
                            navService.canViewNav(nav) 
                            && nav.icon
                            && nav.name != ""
                        ) {
                            <a 
                                class="drawer-icon" 
                                [routerLink]="nav.href ?? nav.path"
                            >
                                <fa-icon 
                                    class="drawer-icon pointer"
                                    [icon]="nav.icon" 
                                    [class.active-drawer-item]="nav.name === navService.selectedMainNav()"
                                ></fa-icon>
                            </a>						
                        }
                    }

                    <fa-icon 
                        [icon]="faUser" 
                        class="drawer-icon pointer"
                        [class.active-drawer-item]='navService.selectedMainNav() === "profile"'
                        (click)="takeToMyProfile()"
                    ></fa-icon>
                </nav>
            }   
            <!--#endregion-->         

            <!--#region Everything else -->
            <div 
                [ngClass]="
                    !isLoggedIn() 
                        ? '' 
                        : navService.isNavFixed() 
                            ? 'left-shift-fixed' 
                            : 'left-shift'
                "
            >
                <pcg-header 
                    id="mainTopHeader" 
                    (hamburgerClick)="navService.toggleNavOpen($event)" 
                    [tabPanel]="tabPanel"
                    [onChangePasswordScreen]="onChangePasswordScreen"
                ></pcg-header>

                <div 
                    [ngClass]="
                        !isLoggedIn() 
                            ? '' 
                            : navService.isNavFixed() 
                                ? 'top-shift-fixed' 
                                : 'top-shift'
                    "
                    class="mb-3"
                >
                    <div 
                        role="main" 
                        class="main-container"
                    >
                        <mat-tab-nav-panel 
                            #tabPanel 
                            class="container"
                            [class]="navService?.selectedMainNav() === 'Home' ? 'mt-75px' : ''"
                        >
                            <router-outlet></router-outlet>
                        </mat-tab-nav-panel>
                    </div>
                    <pcg-system-message></pcg-system-message>
                    <pcg-spinner></pcg-spinner>
                </div>
            </div>
            <!--#endregion-->

            @if (!navService.isMobile()) {
                <div class="footer-ctnr no-print">
                    <div class="footer p-2">
                        System by
                        <a 
                            rel="noreferrer noopener" 
                            href="http://www.paulconsultinggroup.com" 
                            target="_blank"
                        >Paul Consulting Group</a>
                        @if (isLoggedIn()) {
                            <span id="versionHistory">
                                &nbsp;|&nbsp;
                                <a 
                                    onclick="$router.navigateByUrl('release-notes'); return false;" 
                                    href="release-notes"
                                >Release Notes</a>
                                &nbsp;|&nbsp;
                                <a 
                                    class="blue-link" 
                                    href="/eula" 
                                    class="blue-link" 
                                    target="_blank"
                                >EULA</a>
                                &nbsp;|&nbsp;
                                <a 
                                    class="blue-link" 
                                    href="/privacy-policy" 
                                    target="_blank"
                                    class="blue-link" 
                                >Privacy Policy</a>
                                &nbsp;|&nbsp;
                                <a 
                                    class="blue-link" 
                                    href="/terms-and-conditions" 
                                    target="_blank"
                                    class="blue-link" 
                                >Terms and Conditions</a>
                                &nbsp;|&nbsp;
                                <a 
                                    onclick="$router.navigateByUrl('/help/pwa'); return false;" 
                                    href="/assets/PwaHelpFile/PWA.pdf"
                                >PWA</a>
                            </span>
                        }
                    </div>
                </div>
            }
            
        </mat-sidenav-content>
    </mat-sidenav-container>    
}